import { useEffect, useState } from 'react';
import { userService } from '@/shared/services/userService';

/**
 * An object URL for the signed-in person's own photo, or null when they have
 * none or it cannot be read. The image is fetched again when the stored photo
 * changes (its uploadedAt) and the URL is revoked when it is replaced or the
 * component unmounts.
 */
export function useOwnPhotoUrl(photo) {
    const [url, setUrl] = useState(null);
    const stamp = photo?.uploadedAt ?? null;

    useEffect(() => {
        if (!stamp) {
            setUrl(null);
            return undefined;
        }
        let cancelled = false;
        let created = null;
        userService
            .downloadPhoto()
            .then((blob) => {
                if (cancelled) return;
                created = URL.createObjectURL(blob);
                setUrl(created);
            })
            .catch(() => {
                if (!cancelled) setUrl(null);
            });
        return () => {
            cancelled = true;
            if (created) URL.revokeObjectURL(created);
        };
    }, [stamp]);

    return url;
}

export default useOwnPhotoUrl;
